import { useUpdate } from 'ahooks';
import { useEffect, useMemo } from 'react';
import { fetchSvgContentWithCache, getVectorTextFromCache } from '@/utils/file-kit';
import { type TextFragment } from '@/utils/text-kit';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { ArtTextSVGCreator } from '../utils';

export const useArtText = (layer: ILayerProps, fragments: TextFragment[]) => {
    const layerData = layer.data as ITextLayerProps;
    const advancedTextMaterial = layerData.advancedTextMaterial;
    const material = advancedTextMaterial?.material;
    const { fontSize } = layerData;

    const cachedSVGContent = material ? getVectorTextFromCache(material.src) : '';
    const updateManual = useUpdate();

    const artTextSVG = useMemo(() => {
        if (!material?.src || !cachedSVGContent) return null;
        const result = ArtTextSVGCreator.create(layer, fragments, cachedSVGContent);

        return result;
    }, [material?.src, cachedSVGContent, fragments, fontSize]);

    useEffect(() => {
        if (!material?.src || !!cachedSVGContent) return;

        fetchSvgContentWithCache(material.src).then(() => {
            updateManual();
        });
    }, [material?.src, cachedSVGContent]);

    return {
        artTextSVG,
    };
};
